import type { Action } from 'redux';
import dash_api from '../../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../../services/ReduxAsyncAction';
import type { GetCriteoAuthenticationUrlPayload } from '../Criteo.types';

const GetCriteoAuthenticationUrl = new ReduxAsyncAction<
  'GET_CRITEO_AUTHENTICATION_URL',
  void,
  GetCriteoAuthenticationUrlPayload
>('GET_CRITEO_AUTHENTICATION_URL');
GetCriteoAuthenticationUrl.registerRequest(() => {
  return dash_api.get('/v1/criteo/get-auth-url').then(({ data }) => {
    return data;
  });
});
export const GET_CRITEO_AUTHENTICATION_URL = GetCriteoAuthenticationUrl.actionNamespaceConstants;
export const getCriteoAuthenticationUrl = GetCriteoAuthenticationUrl.request;

export type GetCriteoAuthenticationUrlAction = Action<typeof GET_CRITEO_AUTHENTICATION_URL.response> & {
  data: GetCriteoAuthenticationUrlPayload;
};
